import gql from 'graphql-tag'

export default gql`
query getregistrationCount($slug: String, $userType: String){
  registrationCount(filter: {
    AND:[{slug : $slug},{profile:{userType: $userType}}]
  })
}
`
